import { render, staticRenderFns } from "./BookingCancelFeeEtcPop.vue?vue&type=template&id=efccf084"
import script from "./BookingCancelFeeEtcPop.vue?vue&type=script&lang=js"
export * from "./BookingCancelFeeEtcPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efccf084')) {
      api.createRecord('efccf084', component.options)
    } else {
      api.reload('efccf084', component.options)
    }
    module.hot.accept("./BookingCancelFeeEtcPop.vue?vue&type=template&id=efccf084", function () {
      api.rerender('efccf084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BookingCancelFeeEtcPop.vue"
export default component.exports